exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".commercial-banner{max-height:0;overflow:hidden;transition:max-height .5s ease-out}.commercial-banner.loaded{max-height:90px}", ""]);

